import axios from 'axios';
import { API_BASE_URL as PRICING_API_BASE_URL } from './apiConfig';

const pricingApi = axios.create({
  baseURL: PRICING_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Pricing API endpoints for the new cmpd_ tables

// Get available minerals from pricing data
export const getPricingMinerals = async () => {
  try {
    const response = await pricingApi.get('/api/pricing/minerals');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch pricing minerals');
  }
};

// Get available years from pricing data
export const getPricingYears = async () => {
  try {
    const response = await pricingApi.get('/api/pricing/years');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch pricing years');
  }
};

// Get pricing data for a specific mineral
export const getPricingData = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/data', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch pricing data');
  }
};

// Get monthly growth data
export const getMonthlyGrowthData = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/monthly-growth', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch monthly growth data');
  }
};

// Get year-over-year growth data
export const getYearOverYearGrowthData = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/yoy-growth', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch YoY growth data');
  }
};

// Get rolling averages data
export const getRollingAveragesData = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/rolling-averages', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch rolling averages data');
  }
};

// Get 3-year summary data
export const getThreeYearSummary = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/three-year-summary', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch 3-year summary data');
  }
};

// Get 5-year summary data
export const getFiveYearSummary = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/five-year-summary', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch 5-year summary data');
  }
};

// Get growth vs 3-year data
export const getGrowthVs3Year = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/growth-vs-3y', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch growth vs 3-year data');
  }
};

// Get growth vs 5-year data
export const getGrowthVs5Year = async (mineral) => {
  try {
    const response = await pricingApi.get('/api/pricing/growth-vs-5y', {
      params: { mineral }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch growth vs 5-year data');
  }
};

// Get comprehensive pricing data (all metrics for a mineral)
export const getComprehensivePricingData = async (mineral, year = "All") => {
  try {
    const response = await pricingApi.get('/api/pricing/comprehensive-data', {
      params: { mineral, year }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch comprehensive pricing data');
  }
};

// Get pricing KPIs (Top Gainer, Biggest Decline, Volatility Leader, Month of Sharpest Movement)
export const getPricingKPIs = async () => {
  try {
    const response = await pricingApi.get('/api/pricing_kpi');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch pricing KPIs');
  }
};

export default pricingApi;
